import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from "./router"
import axios from 'axios'

import {RUTA_BASE} from '@/constants'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
	// Estas variables son modificadas por los valores definidos en parametros.json
	idiomas: {
		"Español": 1,
		"Euskera": 2,
		"Catalán": 3,
	},
	idioma: 'Español',
	editor: true,
	allbox_web_version: '2.89',
	homepage: 'contratar2',  // esta puede ser principal, contratar o contratar2
	
	api_key: null,
	pago_pasarela: null,
	tipo_pasarela: null,
	sin_dni: null,
	sin_cuenta_banco: null,
	centro_pasarela: null,
	ruta_pasarela: null,
	ruta_pasarela_banco: null,
	ruta_pasarela_banco_pruebas: null,
	ruta_favicon: null,
	fecha_inicio_deshabilitada: null,
	header_simple: null,
	header_solida: null,
	controlar_NIF: null,
	logo_altura: null,
	logo_altura: null,
	titulo_web: null,
	cliente_nombre: null,
	ruta_web_cliente: null,
	menu_color: "",
	apellido2_obligatorio: null,
	cp_obligatorio: null,
	localidad_obligatorio: null,
	provincia_obligatorio: null,
	checkDatos: null,
  },
  mutations: {
	// Mutaciones para modificar el estado
	set_api_key(state, value) {
		state.api_key = value;
	},
	set_pago_pasarela(state, value) {
		state.pago_pasarela = value;
	},
	set_tipo_pasarela(state, value) {
		state.tipo_pasarela = value;
	},
	set_sin_dni(state, value) {
		state.sin_dni = value;
	},
	set_sin_cuenta_banco(state, value) {
		state.sin_cuenta_banco = value;
	},
	set_centro_pasarela(state, value) {
		state.centro_pasarela = value;
	},
	set_ruta_pasarela(state, value) {
		state.ruta_pasarela = value;
	},
	set_ruta_pasarela_banco(state, value) {
		state.ruta_pasarela_banco = value;
	},
	set_ruta_pasarela_banco_pruebas(state, value) {
		state.ruta_pasarela_banco_pruebas = value;
	},
	set_fecha_inicio_deshabilitada(state, value) {
		state.fecha_inicio_deshabilitada = value;
	},
	set_header_simple(state, value) {
		state.header_simple = value;
	},
	set_header_solida(state, value) {
		state.header_solida = value;
	},
	set_menu_color(state, value) {
		state.menu_color = value;
	},
	set_controlar_NIF(state, value) {
		state.controlar_NIF = value;
	},
	set_logo_altura(state, value) {
		state.logo_altura = value;
	},
	set_titulo_web(state, value) {
		state.titulo_web = value;
		document.title = value;
	},
	set_ruta_favicon(state, value) {
		state.ruta_favicon = value;
	},
	set_cliente_nombre(state, value) {
		state.cliente_nombre = value;
	},
	set_ruta_web_cliente(state, value) {
		state.ruta_web_cliente = value;
	},
	set_apellido2_obligatorio(state, value) {
		state.apellido2_obligatorio = value;
	},
	set_cp_obligatorio(state, value) {
		state.cp_obligatorio = value;
	},
	set_localidad_obligatorio(state, value) {
		state.localidad_obligatorio = value;
	},
	set_provincia_obligatorio(state, value) {
		state.provincia_obligatorio = value;
	},

	set_checkDatos(state, value){
		state.checkDatos = value;
	},
	
	set_homepage(state, value) {
		state.homepage = value;
	}
  },
  actions: {
	// Acciones asíncronas para realizar operaciones
	async cargarConstantes({ commit }) {
	  try {
		const response = await axios.get(`${RUTA_BASE}json/parametros.json`);
		const data = response.data;
		commit('set_api_key', data.api_key);
		commit('set_pago_pasarela', data.pago_pasarela);
		commit('set_tipo_pasarela', data.tipo_pasarela);
		commit('set_sin_dni', data.sin_dni);
		commit('set_sin_cuenta_banco', data.sin_cuenta_banco);
		commit('set_centro_pasarela', data.centro_pasarela);
		commit('set_ruta_pasarela', data.ruta_pasarela);
		commit('set_ruta_pasarela_banco', data.ruta_pasarela_banco);
		commit('set_ruta_pasarela_banco_pruebas', data.ruta_pasarela_banco_pruebas);
		commit('set_fecha_inicio_deshabilitada', data.fecha_inicio_deshabilitada);
		commit('set_header_simple', data.header_simple);
		commit('set_header_solida', data.header_solida);
		commit('set_controlar_NIF', data.controlar_NIF);
		commit('set_logo_altura', data.logo_altura);
		commit('set_titulo_web', data.titulo_web);
		commit('set_menu_color', data.menu_color);
		commit('set_ruta_favicon', data.ruta_favicon);
		commit('set_cliente_nombre', data.cliente_nombre);
		commit('set_ruta_web_cliente', data.ruta_web_cliente);
		commit('set_apellido2_obligatorio', data.apellido2_obligatorio);
		commit('set_cp_obligatorio', data.cp_obligatorio);
		commit('set_localidad_obligatorio', data.localidad_obligatorio);
		commit('set_provincia_obligatorio', data.provincia_obligatorio);
		commit('set_checkDatos', data.checkDatos);
		

	  } catch (error) {
		console.error("Error al cargar las constantes", error);
	  }
	}
  },
  getters: {
	// Getters para obtener valores del estado
  }
})

export default store
